export default {
  '12_HOUR': '12-hour',
  '24_HOUR': '24-hour',
};
